import { useState } from "react";
import "./ParkingLogin.css";

// SVG Icons
const PIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M6 4h7a4 4 0 0 1 0 8H6V4z" fill="white" />
    <path d="M6 12v8" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="2" y="4" width="20" height="16" rx="3" />
    <path d="m2 7 10 7 10-7" />
  </svg>
);

const LockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const EyeIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-10-7-10-7a21.8 21.8 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A10.94 10.94 0 0 1 12 5c7 0 10 7 10 7a21.8 21.8 0 0 1-4.06 5.06" />
    <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ArrowRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

export default function ParkingLogin({ setPage }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [keepLoggedIn, setKeepLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};

    if (!email) errs.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(email))
      errs.email = "Enter a valid email";

    if (!password) errs.password = "Password is required";
    else if (password.length < 6)
      errs.password = "At least 6 characters";

    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errs = validate();
    setErrors(errs);

    if (Object.keys(errs).length > 0) return;

    setLoading(true);

    setTimeout(() => {
  setLoading(false);
  setPage("dashboard");
}, 2200);
  };

  return (
    
    <div className="login-root">
  <div className="login-center">

    <div className="login-card">
        {/* Brand */}
        <div className="brand">
          <div className="logo">P</div>
<h1>Parking MS</h1>
        </div>

        {/* Heading */}
        <div className="heading-block">
          <h1>Sign In to Parking MS</h1>
          <p>Access your parking terminal controller</p>
        </div>

        {/* Form */}
        <form className="form" onSubmit={handleSubmit} noValidate>
          {/* Email */}
          <div className="field-group">
            <label className="field-label">Email Address</label>

            <div className="input-wrapper">
              <span className="input-icon">
                <MailIcon />
              </span>

              <input
                className={`input-field${errors.email ? " error" : ""}`}
                type="email"
                placeholder="Enter Your Email ID"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((p) => ({ ...p, email: "" }));
                }}
              />
            </div>

            {errors.email && (
              <span className="error-msg">{errors.email}</span>
            )}
          </div>

          {/* Password */}
          <div className="field-group">
            <div className="field-label-row">
              <label className="field-label">Password</label>


              <a
  href="#"
  className="forgot-link"
  onClick={(e) => {
    e.preventDefault();
    setPage("forgot");
  }}
>
  Forgot Password?
</a>
            </div>

            <div className="input-wrapper">
              <span className="input-icon">
                <LockIcon />
              </span>

              <input
                className={`input-field${errors.password ? " error" : ""}`}
                type={showPassword ? "text" : "password"}
                placeholder="Enter Your Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors((p) => ({ ...p, password: "" }));
                }}
              />

              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>

            {errors.password && (
              <span className="error-msg">{errors.password}</span>
            )}
          </div>

          {/* Checkbox */}
          <div
            className="checkbox-row"
            onClick={() => setKeepLoggedIn((v) => !v)}
          >
            <div
              className={`custom-checkbox${
                keepLoggedIn ? " checked" : ""
              }`}
            />

            <span className="checkbox-label">
              Keep me logged in
            </span>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className={`login-btn${loading ? " loading" : ""}`}
          >
            {loading ? (
              <>
                <div className="spinner" />
                Signing in...
              </>
            ) : (
              <>
                Log In <ArrowRight />
              </>
            )}
          </button>

          {/* Signup */}
          <div className="signup-row">
            Don't have an account?{" "}
            <a href="#" className="signup-link">
              Sign up for a new account
            </a>
          </div>
        </form>
      </div>

      {/* Footer */}
        <div className="card-footer">
          <a href="#" className="footer-link">
            Privacy Policy
          </a>

          <div className="footer-dot" />

          <a href="#" className="footer-link">
            Terms of Service
          </a>

          <div className="footer-dot" />

          <a href="#" className="footer-link">
            Help Center
          </a>
        </div>
          </div>
    </div>
  );
}